module.exports = __webpack_public_path__ + "img/EmptySuccessVacation.08b169f4.svg";